export const PORTAL_BETA_HOSTNAME = "portal.strobeaviation.com";

export const isPortalBetaHost = () => {
  if (typeof window === "undefined") return false;
  return window.location.hostname === PORTAL_BETA_HOSTNAME;
};
